import { InjectionToken } from '@angular/core';
// ─── Configuration ────────────────────────────────────────────────────────────

export interface MonobankApiConfig {
  apiUrl?: string;
  rateLimitMs?: number;
}

export const MONOBANK_API_CONFIG = new InjectionToken<MonobankApiConfig>('MONOBANK_API_CONFIG');
